$(".m-form--bulkywaste-address select").on("click", function () {
    $(".bw-no-address").show();
});

$(".m-form--bulkywaste-address .m-edit .has-js").on("click", function () {
    $(".bw-no-address").hide();
});

$(".multiple-select-to-result-field label").each(function () {
    var text = $(this).text();
    text = text.replace("(SPECIFY)", "");
    $(this).text(text);
});
$(".lbi-table-cell").each(function () {
    var text = $(this).text();
    text = text.replace("(SPECIFY)", "");
    $(this).text(text);
});

$(".lbi-table-row th label").each(function () {
    var text = $(this).text();
    text = text.replace("(SPECIFY)", "");
    $(this).text(text);
});
$(".field-validation-error").each(function () {
    var text = $(this).text();
    text = text.replace("(SPECIFY)", "");
    $(this).text(text);
});

$(".multiple-select-to-result-field select").on("change", function () {
   
    $(this).closest('.multiple-select-to-result-field').find(".m-wizard-question-heading").show();
    $(this).closest('.multiple-select-to-result-field').find("textarea").show();
});


$('.m-wizard-question-heading').hide();
$('.multiple-select-to-result-field textarea').hide();
$('#calcCostsBtn').hide();

    var count = -1;

    $('.multiple-select-lower-result-form .multiple-select-to-result-field textarea').each(function () {
        if ($(this).text().trim().length) {
            $(this).show();
           
        }
    });

    $('.multiple-select-lower-result-form .multiple-select-to-result-field select').on("change", function () {

        count++;
        var strChosen = $(this).attr('name');
        var strChosenL = $(this).closest('.multiple-select-to-result-field').find("label").text();
        var strChosenRef = $(this).closest('.multiple-select-to-result-field').attr('id');
        var strChosenID = $(this).attr('id');
      

        $('#bref_' + strChosenRef).remove();
        $('#ref_' + strChosenRef).remove();
       
        var hasATextarea = $(this).closest('.multiple-select-to-result-field').find('textarea').attr('id');
   
        if (hasATextarea === undefined) {

            var myTextArea = "";
            var myRowSpan = "1";
        }
        else {
            var excistingValue = $('#' + hasATextarea).val();
           
            var thisValueWasHere = excistingValue;

            var myRowSpan = "2";
            
            if (excistingValue = "") {
                var myTextArea = '<tr id="bref_' + strChosenRef + '"><td><div class="final-additional-text"></div></td></tr>';
            }
            else {
                
                var myTextArea = '<tr id="bref_' + strChosenRef + '"><td><div class="final-additional-text">' + thisValueWasHere + '</div></td></tr>';
              
            }
        }

        var previousSelectVal = $(this).val();
  
    
        $('.m-result-table tr:first').before('<tr id="ref_' + strChosenRef + '" class="lbi-table-row"><th rowspan="' + myRowSpan + '" class="lbi-table-cell" >' + strChosenL + '</td><td class="lbi-table-cell bulky-waste-table-cell">' + previousSelectVal + '</td></tr>' + myTextArea + '');
       
        var selectId = 'bulkySelect' + strChosen;


        if (previousSelectVal == 0) {

            $('#ref_' + strChosenRef).remove();
            $('#bref_' + strChosenRef).remove();
        }

    });

    // copy text upper textarea to lower textarea
    $('.multiple-select-lower-result-form .multiple-select-to-result-field textarea').on("focusout",function () {
     
        var myContent = $(this).val();
        var trid = $(this).closest('li').attr('id'); // table row ID 
        $('#bref_' + trid + ' .final-additional-text').html(myContent);
    
        
    });
    // copy text lower textarea to upper textarea
  

    $('.m-result-table span.custom-select select').on("change", function () {
    var previousSelectVal = $(this).val();
    
   
    var strChosenRef = $(this).closest('tr').attr('id');
    //   var strChosenID = $(this).attr('id');

    if (previousSelectVal == 0) {
        $('#' + strChosenRef).remove();
        $.fancybox('<div id="tooMany"><p>Are you sure you want to remove these?</p></div>');
    }

});

$('td.bulky-waste-table-cell textarea').on('input', function () {
    
    var trid = $(this).closest('tr').attr('id'); // table row ID 

    var liid = +trid.replace("ref_", "");

    
    $(this).each(function (idxx) {
        $('#' + liid + ' textarea').eq(idxx).val($(this).val());
    });
});
// Function for revealing elements with a select option for bulky waste
$(".lbi-select-reveal").hide();
$(".lbi-select-trigger").on("change", function () {
    if ($(this).val() != "0") {
        $(this).next(".lbi-select-reveal").show();
    } else {
        $(this).next(".lbi-select-reveal").hide();
    }
});


//Prevent more than 10 items
var totalChosen = (function () {
    var chosen = 0;
    $('.multiple-select-to-result-field select :selected').each(function () {
        chosen += Number($(this).val());

    });
    if (chosen > 10) {
        $('.bulky-waste-total-select select').css('opacity', '1');
     
     //   $.fancybox('<div id="tooMany"><p>You cannot select more than 10 items per transaction</p></div>');

    }
    else {
        $('.bulky-waste-total-select select').css('opacity', '1');

        var limitNumber = 10 - chosen;
   
        
        if (chosen > 9) {

            $('.multiple-select-to-result-field select').each(function () {
                $('#Model.SelectWasteItemStage.ItemSummary.WasteItemGroups[7].WasteItems[0].ItemQuantity option[value="10"]').prop('disabled', true);
               
            });
        }

    }

});

$('.multiple-select-to-result-field select')
    .on("change", totalChosen)

$(".m-result-table").on('change')
    .on('change', totalChosen)
var alreadyGotDiscount = $('#SelectWasteItemStage_DiscountCodeIsValid').val();


if (alreadyGotDiscount == 'True') {

    $('#discountConfirmMessage').show();
}
else {

    $('#SelectWasteItemStage_DiscountCode').show();
    $('#calcButtonNoneJS').hide();
    $('#discountConfirmMessage').hide();
    $('#calcButtonJS').show();
}
//Show and hide the discount row

$('#calcCostsJS').on("click", function (event) {
    event.preventDefault();
    var myDiscountCode = $('#SelectWasteItemStage_DiscountCode').val();

    var rege = /^((0*([1-9]\d{0,3}))|\d{6}|\d{8})$/;
    if (rege.test($('#SelectWasteItemStage_DiscountCode').val())) {

        var theDiscount = $('#myDiscountAmount').val();
       
        $('#m-form-lower-result tr:last').before('<tr id="discount-row"><th scope="row">Discount</th><td align="right"><span id="total-discount">' + theDiscount + '</span><span>%</span><button type="submit" class="btn btn-icon" id="bulky-waste-remove-button" name="FormSubmitAction" value="RemoveDiscount" data-spinner="activate">Remove</button></td></tr>');
      
        var discountPerc = $('#SelectWasteItemStage_DiscountPercentage').val();
        var discountValueCalc = discountPerc / 100;
        
        $('#total-discount').val(discountValueCalc);

        $('#calcButtonJS').hide();
        $('#SelectWasteItemStage_DiscountCode').hide();
        $('.multiple-select-lower-result-form #SelectWasteItemStage_DiscountCodeIsValid').val("True");
        $('#discountConfirmMessage').show();

    }
    else {
       
    }

});


// Function for editing the total items and cost table
$("button.bulky-waste-edit-button").on("click", function () {
    $(this).next('.bulky-waste-total-select').prop('disabled', function (i, v) { return !v; });
    $(this).next('.bulky-waste-total-select').css('width', '100%');
    $(this).toggleClass("editable"); //Switch the icon to the confirm icon
    $(this).hide(); // Hide the edit button when it's clicked
});

// Function for calculating the number of items
var totalItems = (function () {
   
 
    var sum = 0;

    $('.lbi-table-row .bulky-waste-table-cell').each(function () {
        sum = sum + parseInt($(this).html());
        
    });

    var discountCodeForBW = $('#SelectWasteItemStage_DiscountCodeIsValid').val();

    if (discountCodeForBW == 'True') {
        var discount = 0.5;
    }
    else {
        var discount = 1;
    }

    $("#result-table-total-items").html(sum);

    if (sum < 3) {
        sum = 3;
    }

    if (sum > 10) {
        $.fancybox('<div id="tooMany"><p>You cannot select more than 10 items per transaction</p></div>');
    }

    var maxItemsToPick = $('#SelectWasteItemStage_MaxItemsPerTransaction').val();

    if (sum > maxItemsToPick) {
        $("#bulky-waste-total-cost").html("---");
    }

    else {
        $("#bulky-waste-total-cost").html("£" + sum * discount * 10.66);
    }

});

$(".m-result-table").on("load")
   .ready(totalItems)
   .on("change", totalItems)


$(".m-result-table").on('change')
   .ready(totalItems)
   .on('change', totalItems)

$(".multiple-select-lower-result-form").on('change')
   .ready(totalItems)
   .on('change', totalItems)

$(".bulky-waste-total-select").on('change')
.ready(totalItems)
.on("change", totalItems)

$(document).ready(function () {

    $(totalItems);
   
});

if ($("#discount-row").length != 0) {
    $(totalItems);
    
}



$(function () {
    var previous = $(".m-result-table").text();
    $check = function () {
        if ($(".m-result-table").text() != previous) {
            $(totalItems);
        }
        previous = $(".m-result-table").text();
    }
    setInterval(function () { $check(); }, 1000);
});



$('select.bulky-waste-total-select select')
    .ready(totalItems)
    .on("change", totalItems)

$('#totalcost-button, .bulky-waste-remove-button')
    .on("click", totalItems)

$('#discount-button, .bulky-waste-remove-button')
    .on("click", totalItems)

